import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faCalendarAlt, 
  faUser, 
  faClock, 
  faPhone, 
  faMapMarkerAlt, 
  faArrowLeft, 
  faHome
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/PaymentResult.css';
import { useTranslation } from 'react-i18next';

const PaymentDone = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [lastYuyueRecord, setLastYuyueRecord] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // 从location中获取最新预约信息，如果没有则从用户信息中获取
  useEffect(() => {
    if (location.state && location.state.appointmentData) {
      setLastYuyueRecord(location.state.appointmentData);
    } else if (user && user.yuyueRecords && user.yuyueRecords.length > 0) {
      // 获取最新的预约记录
      const sortedRecords = [...user.yuyueRecords].sort((a, b) => 
        new Date(b.startTime) - new Date(a.startTime)
      );
      setLastYuyueRecord(sortedRecords[0]);
    }
  }, [user, location]);

  const formatDate = (dateString) => {
    if (!dateString) return t('table.status');
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  // 获取预约状态文本
  const getStatusText = (record) => {
    if (!record) return t('table.status');
    
    if (record.paymentStatus === 1) {
      return t('payment.paid');
    } else if (record.paymentStatus === 0) {
      return record.paymentMethod === 2 ? t('payment.pendingPayment') : t('booking.pending');
    } else if (record.paymentStatus === 2) {
      return t('payment.cancelled');
    }
    return t('table.status');
  };

  return (
    <div className="home-page">
      <Header />
      <div className="payment-result-container payment-success">
        <div className="payment-result-icon">
          <FontAwesomeIcon icon={faCheckCircle} />
        </div>
        
        <div className="payment-result-header">
          <h1>{t('payment.paymentSuccess')}</h1>
          <p className="payment-result-message">
            {t('payment.appointmentCreatedSuccess')}
          </p>
        </div>
        
        {lastYuyueRecord ? (
          <div className="payment-details">
            <h2>{t('booking.appointmentDetail')}</h2>
            <div className="payment-detail-item">
              <span className="detail-label">
                <FontAwesomeIcon icon={faCalendarAlt} /> {t('booking.appointmentNumber')}
              </span>
              <span className="detail-value">{lastYuyueRecord.id}</span>
            </div>
            <div className="payment-detail-item">
              <span className="detail-label">
                <FontAwesomeIcon icon={faUser} /> {t('userMgmt.name')}
              </span>
              <span className="detail-value">{lastYuyueRecord.xingming}</span>
            </div>
            <div className="payment-detail-item">
              <span className="detail-label">
                <FontAwesomeIcon icon={faUser} /> {t('booking.coach')}
              </span>
              <span className="detail-value">{lastYuyueRecord.jiaolianbianhao}</span>
            </div>
            <div className="payment-detail-item">
              <span className="detail-label">
                <FontAwesomeIcon icon={faClock} /> {t('booking.time')}
              </span>
              <span className="detail-value">{formatDate(lastYuyueRecord.startTime)}</span>
            </div>
            <div className="payment-detail-item">
              <span className="detail-label">
                <FontAwesomeIcon icon={faPhone} /> {t('userMgmt.phone')}
              </span>
              <span className="detail-value">{lastYuyueRecord.shouji}</span>
            </div>
            {lastYuyueRecord.address && (
              <div className="payment-detail-item">
                <span className="detail-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} /> {t('userMgmt.address')}
                </span>
                <span className="detail-value">{lastYuyueRecord.address}</span>
              </div>
            )}
            <div className="payment-detail-item">
              <span className="detail-label">{t('payment.paymentStatus')}</span>
              <span className="detail-value">{getStatusText(lastYuyueRecord)}</span>
            </div>
          </div>
        ) : (
          <div className="payment-details">
            <p>{t('booking.noAppointmentRecords')}</p>
          </div>
        )}
        
        <div className="payment-actions">
          <Link to={`/user-appointment`} className="payment-btn btn-primary">
            <FontAwesomeIcon icon={faCalendarAlt} /> {t('booking.myAppointments')}
          </Link>
          <Link to="/" className="payment-btn btn-secondary">
            <FontAwesomeIcon icon={faHome} /> {t('payment.homeBtn')}
          </Link>
        </div>
        
        <div className="payment-tips">
          <p>{t('payment.appointmentCreated')}</p>
          <p>{t('payment.contactSupport')}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentDone;